import actions from './actions'
import mutations from './mutation'

const state = {
  //当前订阅区块链的chainCid
  chainCid: '',
  //ca列表
  ca_list: [],
  ca_paging: {
    offset: 0,
    limit: 10,
    total: 0
  }
}

export default {
  state,
  actions,
  mutations
}
